import { type Common } from './common.js';

export class API {
  common: Common;
  baseEndpoint = '/vidyard';

  constructor(common: Common) {
    this.common = common;
  }

  async getToken(props: { playerUuid: string }): Promise<{ token: string }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/token`, {
      playerUuid: props.playerUuid,
    });
    return await this.common.getJSON(url);
  }
}
